export var isUrl = function (text) {
    var isHttp = text.slice(0, 4) === "http";
    var isHttps = text.slice(0, 5) === "https";
    return isHttp || isHttps;
};
